module.exports = __webpack_public_path__ + "img/mx_seguromovil.2bad8da4.png";